import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// 各个页面组件
import Aaya from './pages/aya/aya';
import ErrorBoundary from './components/ErrorBoundary';
import { observer } from 'mobx-react-lite';

const App = observer(() => {
  return (
    <ErrorBoundary>
      <Router>
        <div className='min-h-screen'>
          {/* <div className="sticky top-0 z-10 bg-black">
            <Head />
          </div> */}
          <div>
            <Routes>
              <Route path="/" element={<Navigate to="/gptia/" replace />} />
              <Route path="/gptia/" element={<Aaya />} />
            </Routes>
          </div>

        </div>
      </Router>
    </ErrorBoundary>
  );
});

export default App;
